<button class="btn btn-success btn-block" [disabled]="!isEnabled || isBlocked || isLocked" (click)="callTicket()" title="{{ tooltipTitle }}" #button>
    <i class="fas fa-bell" #icon></i>
    <span class="element-text">{{ 'console.call' | translate }}</span>
</button>